import {
  FormControl,
  FormField,
  FormGroup,
  FormLabel,
  FormMessage,
} from "@/components/form"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { InputFieldProps } from "@/components/ui/input-field"
import { cn } from "@/lib/cn"
import { useTranslations } from "next-intl"
import { useRef, useState } from "react"
import { EyeClosed, EyeOpenSvg } from "./svg"

type InputPasswordFieldProps = InputFieldProps & { newPassword?: boolean }

export function InputPasswordField({
  label,
  fieldStateReducer,
  hideMessage,
  newPassword = false,
  ref,
  ...field
}: InputPasswordFieldProps) {
  const t = useTranslations()

  const inputRef = useRef<HTMLInputElement | null>(null)

  const [isVisible, setVisibility] = useState(false)

  const isSnai = window.APP_VENDOR === "snai"

  const handleVisibility = () => {
    setVisibility((v) => !v)
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus()

        inputRef.current.selectionStart = inputRef.current.selectionEnd =
          inputRef.current.value.length
      }
    }, 0)
  }

  return (
    <FormField name={field.name} fieldStateReducer={fieldStateReducer}>
      <FormGroup>
        <FormControl>
          <Input
            {...field}
            ref={(e) => {
              if (typeof ref === "function") ref(e as any)
              inputRef.current = e
            }}
            type={isVisible ? "text" : "password"}
            className={cn(
              "pr-[2.7rem]! [&::-ms-clear]:hidden [&::-ms-reveal]:hidden",
              isSnai && "autofill-btn-text",
            )}
            autoComplete={newPassword ? "new-password" : "on"}
          />
        </FormControl>
        <Button
          type="button"
          variant="ghost"
          className="group-data-[ui-state=error]:text-field-error group-data-[ui-state=warn]:text-field-warning absolute top-1/2 right-4 h-[unset]! -translate-y-1/2 p-0!"
          aria-label={isVisible ? "hide password" : "show password"}
          onClick={handleVisibility}
        >
          {isVisible ? <EyeOpenSvg /> : <EyeClosed />}
        </Button>
        <FormLabel>{t(label)}</FormLabel>
      </FormGroup>
      {!hideMessage && <FormMessage data-qa={"form-error-" + field.name} />}
    </FormField>
  )
}
